export default __webpack_public_path__ + "static/media/feb2023-4.5700d750.jpg";